module.exports = __webpack_public_path__ + "img/myPic3.df9adc91.jpeg";